@if (showLoader()) {
  <section class="loaderwrp">
    <div class="scale-loader">
      <div class="dot-pulse"></div>
    </div>
  </section>
}

<div class="px24-700">
  <form [formGroup]="personalDetailsForm">
    <div class="registration">
      <div class="reg-wrap mb44 mb28-700">

        <!-- Interested IDP Service (multi-select dropdown) - first question -->
        @for (ppQuestion of questions; track ppQuestion) {
          @if (ppQuestion.displayFormat.value === 'SELECT_BOX' && ppQuestion.mappingField === 'interestedIDPSerivce') {
            <div class="ques-wrap dropdown-field select-p-unset mb44 mb28-700">
              <label class="mb4 d-inline-block">{{ppQuestion.label}}</label>
              <mat-form-field [ngClass]="personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'slct-boxes relative input-error':'slct-boxes relative'">
                <mat-select
                  (selectionChange)="onMultiSelect(ppQuestion.mappingField, $event.value)"
                  formControlName="{{ppQuestion.mappingField}}"
                  id="{{ppQuestion.mappingField}}"
                  multiple aria-label="{{ppQuestion.label}}">
                  @for (optionValue of ppQuestion.options; track optionValue) {
                    <mat-option
                      [value]="optionValue" id="{{optionValue.option_value}}">
                      {{optionValue.option_label}}
                    </mat-option>
                  }
                </mat-select>
                @if (personalDetailsForm.get(ppQuestion.mappingField)?.value?.length) {
                  <button
                    (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()" aria-label="Clear selection"
                    type="button" class="select-clear-icon right-52">
                    <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
                  </button>
                }
              </mat-form-field>
              @if (personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
                <div class="reg-err">
                  {{ppQuestion.helpText}}
                </div>
              }
            </div>
          }
        }

        <!-- Title heading -->
        @for (ppQuestion of questions; track ppQuestion) {
          @if (ppQuestion.mappingField === 'title') {
            <h2 class="ques-hd">{{ppQuestion.label}}</h2>
          }
        }

        <!-- First name / Last name side by side -->
        @for (ppQuestion of questions; track ppQuestion) {
          @if (ppQuestion.mappingField === 'first_name' || ppQuestion.mappingField === 'last_name') {
            <div [ngClass]="{'first-name-field': ppQuestion.mappingField === 'first_name', 'last-name-field': ppQuestion.mappingField === 'last_name'}">
              @if (ppQuestion.mappingField === 'first_name') {
                <div class="flex flex-column flex-1">
                  <label for="firstname" class="mb4 d-inline-block">{{ppQuestion.label}}</label>
                  <mat-form-field>
                    <input [ngClass]="personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'input-error':''"
                      matInput id="firstname" aria-label="first name"
                      formControlName="{{ppQuestion.mappingField}}"
                      (blur)="onInputString(ppQuestion.mappingField, $event)"
                      (keydown.enter)="preventEnter($event)">
                  </mat-form-field>
                  @if (personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
                    <div class="reg-err">
                      {{ppQuestion.helpText}}
                    </div>
                  }
                </div>
              }
              @if (ppQuestion.mappingField === 'last_name') {
                <div class="flex flex-column flex-1">
                  <label for="lastname" class="mb4 d-inline-block">{{ppQuestion.label}}</label>
                  <mat-form-field>
                    <input [ngClass]="{'input-error':personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required')&&submitted}"
                      matInput id="lastname" aria-label="last name"
                      [formControlName]="ppQuestion.mappingField"
                      (blur)="onInputString(ppQuestion.mappingField, $event)"
                      (keydown.enter)="preventEnter($event)">
                  </mat-form-field>
                  @if (personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
                    <div class="reg-err">
                      {{ppQuestion.helpText}}
                    </div>
                  }
                </div>
              }
            </div>
          }
        }

        <!-- Dial code + Mobile number -->
        @for (ppQuestion of questions; track ppQuestion) {
          @if (ppQuestion.displayFormat.value === 'SELECT_BOX' && ppQuestion.mappingField === 'dialCode') {
            <div class="ques-wrap w144 w114 mr8 mb8 dialcode">
              <p class="mb4">{{ppQuestion.label}}</p>
              <div class="cntry-code">
                <mat-form-field appearance="outline" class="slct-boxes">
                  <mat-select (selectionChange)="phoneNumberValidation($event.value)"
                    formControlName="{{ppQuestion.mappingField}}"
                    placeholder="{{ppQuestion.defaultValue}}" aria-label="{{ppQuestion.label}}">
                    @for (optionValue of ppQuestion.options; track optionValue) {
                      <mat-option
                        [value]="optionValue"
                        (click)="onInputChange(ppQuestion.mappingField, optionValue)"
                        id="{{optionValue}}">
                        {{optionValue.dialCode}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                @if (personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
                  <div class="reg-err">
                    {{ppQuestion.helpText}}
                  </div>
                }
              </div>
            </div>
          }
          @if (ppQuestion.mappingField === 'primary_mobile_number') {
            <div class="wmob d-inline-block mb8">
              <p class="mb4">{{ppQuestion.label}}</p>
              <mat-form-field>
              <input [ngClass]="{'input-error':(personalDetailsForm.get(ppQuestion.mappingField)?.hasError('invalidPhoneNumber')
                ||personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required')) && submitted}"
                  matInput maxlength="{{ppQuestion.maxLength}}"
                  (keyup)="phoneNumber(ppQuestion.mappingField)"
                  id="primary_mobile_number" aria-label="primary mobile number"
                  formControlName="{{ppQuestion.mappingField}}"
                  (blur)="onInputString(ppQuestion.mappingField, $event)"
                  (keydown.enter)="preventEnter($event)">
              </mat-form-field>
              @if (ppQuestion.mappingField === 'primary_mobile_number' &&
                personalDetailsForm.get(ppQuestion.mappingField)?.hasError('invalidPhoneNumber') && submitted) {
                <span class="reg-err"
                  >
                  {{phoneNumberInvalidError}}
                </span>
              }
              @if (personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
                <div class="reg-err">
                  {{ppQuestion.helpText}}
                </div>
              }
            </div>
          }
        }

        <!-- Date of Birth -->
        @for (ppQuestion of questions; track ppQuestion) {
          @if (ppQuestion.mappingField === 'date_of_birth') {
            <div class="mb44 mb28-700 dob-field">
              <label for="picker" class="mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
                <span class="optional-text"> {{optionalText}}</span>
              }</label>
              <mat-form-field [ngClass]="{'date-error':(invalidDate || futureDate) && submitted}"
                appearance="fill" class="custom-date-wrapper">
                <input formControlName="{{ppQuestion.mappingField}}"
                  [max]="yesterdayDate"
                  (dateChange)="onDateChange($event)"
                  (keydown.enter)="preventEnter($event)"
                  matInput [matDatepicker]="picker" class="date-picker-input"
                  aria-label="Date of birth" [placeholder]="ppQuestion.defaultValue" />
                <span matSuffix class="date-suffix-icons">
                  @if (personalDetailsForm.get(ppQuestion.mappingField)?.value) {
                    <button
                      (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()" aria-label="Clear date"
                      type="button" class="date-clear-icon">
                      <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
                    </button>
                  }
                  <mat-datepicker-toggle [for]="picker" class="custom-date"></mat-datepicker-toggle>
                </span>
                <mat-datepicker #picker panelClass="custom-datepicker">
                  <mat-datepicker-actions>
                    <button mat-button matDatepickerCancel class="calendar-btn secondary-btn">{{cancelText}}</button>
                    <button mat-raised-button color="primary" matDatepickerApply class="calendar-btn primary-btn">{{applyText}}</button>
                  </mat-datepicker-actions>
                </mat-datepicker>
              </mat-form-field>
              @if (invalidDate && submitted) {
                <div class="reg-err">{{invalidDOBText}}</div>
              }
              @if (futureDate && submitted && !invalidDate) {
                <div class="reg-err">{{futureDOBText}}</div>
              }
            </div>
          }
        }

        <!-- Gender -->
        @for (ppQuestion of questions; track ppQuestion) {
          @if (ppQuestion.displayFormat.value === 'SELECT_BOX' && ppQuestion.mappingField === 'gender') {
            <div class="ques-wrap mb12">
              <label class="mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
                <span class="optional-text"> {{optionalText}}</span>
              }</label>
              <mat-chip-listbox class="tag-list" formControlName="{{ppQuestion.mappingField}}" id="{{ppQuestion.mappingField}}" [attr.aria-label]="ppQuestion.label">
                @for (optionValue of ppQuestion.options; track optionValue) {
                  <mat-chip-option tabindex="0" [aria-label]="ppQuestion.options.option_label" class="tag"
                    id="{{optionValue.option_value}}"
                    [value]="optionValue.option_label"
                    (selectionChange)="onInputChange(ppQuestion.mappingField, optionValue, $event)">
                    {{optionValue.option_label}}
                  </mat-chip-option>
                }
              </mat-chip-listbox>
              @if (personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
                <div class="reg-err">
                  {{ppQuestion.helpText}}
                </div>
              }
            </div>
          }
        }

        <!-- Marital Status -->
        @for (ppQuestion of questions; track ppQuestion) {
          @if (ppQuestion.displayFormat.value === 'SELECT_BOX' && ppQuestion.mappingField === 'maritalStatus') {
            <div class="ques-wrap dropdown-field mb44 mb28-700">
              <label class="mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
                <span class="optional-text"> {{optionalText}}</span>
              }</label>
              <mat-form-field [ngClass]="personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'slct-boxes relative input-error':'slct-boxes relative'">
                <mat-select formControlName="{{ppQuestion.mappingField}}" id="{{ppQuestion.mappingField}}" aria-label="{{ppQuestion.label}}">
                  @for (optionValue of ppQuestion.options; track optionValue) {
                    <mat-option
                      [value]="optionValue.option_label"
                      (click)="onInputChange(ppQuestion.mappingField, optionValue)"
                      id="{{optionValue.option_value}}">
                      {{optionValue.option_label}}
                    </mat-option>
                  }
                </mat-select>
                @if (personalDetailsForm.get(ppQuestion.mappingField)?.value) {
                  <button
                    (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()" aria-label="Clear selection"
                    type="button" class="select-clear-icon right-52">
                    <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
                  </button>
                }
              </mat-form-field>
              @if (personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
                <div class="reg-err">
                  {{ppQuestion.helpText}}
                </div>
              }
              <p class="mt12">{{genderMaritalNoteText}}
                <button class="link-text font-regular" (click)="openLearnMorePopup()">{{learnMoreText}}</button></p>
              </div>
            }
          }

          <!-- Nationality (searchable) -->
          @for (ppQuestion of questions; track ppQuestion) {
            @if (ppQuestion.displayFormat.value === 'SELECT_BOX' && ppQuestion.mappingField === 'nationalityCode') {
              <div class="ques-wrap dropdown-field mb44 mb28-700"
                >
                <label class="mb4 d-inline-block">{{ppQuestion.label}}</label>
                <mat-form-field
                  [ngClass]="personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted ? 'slct-boxes relative input-error' : 'slct-boxes relative'">
                  <mat-select formControlName="{{ppQuestion.mappingField}}" id="{{ppQuestion.mappingField}}" #select aria-label="{{ppQuestion.label}}">
                    <mat-option>
                      <ngx-mat-select-search [formControl]="searchFilterCtrl" noEntriesFoundLabel="No results found"></ngx-mat-select-search>
                    </mat-option>
                    @for (optionValue of filteredOptions | async; track optionValue) {
                      <mat-option
                        [value]="optionValue.option_label"
                        (click)="onInputChange(ppQuestion.mappingField, optionValue)"
                        id="{{optionValue.option_value}}">
                        {{optionValue.option_label}}
                      </mat-option>
                    }
                  </mat-select>
                  @if (personalDetailsForm.get(ppQuestion.mappingField)?.value) {
                    <button
                      (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()" aria-label="Clear selection"
                      type="button" class="select-clear-icon right-52">
                      <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
                    </button>
                  }
                </mat-form-field>
                @if (personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
                  <div class="reg-err">
                    {{ppQuestion.helpText}}
                  </div>
                }
              </div>
            }
          }

          <!-- Have a Passport? -->
          @for (ppQuestion of questions; track ppQuestion) {
            @if (ppQuestion.displayFormat.value === 'SELECT_BOX' && ppQuestion.mappingField === 'passport') {
              <div class="ques-wrap mb44 mb28-700">
                <label class="ques-hd d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
                  <span class="optional-text"> {{optionalText}}</span>
                }</label>
                <mat-chip-listbox class="tag-list" formControlName="{{ppQuestion.mappingField}}" id="{{ppQuestion.mappingField}}" [attr.aria-label]="ppQuestion.label">
                  @for (optionValue of ppQuestion.options; track optionValue) {
                    <mat-chip-option tabindex="0" [aria-label]="ppQuestion.options.option_label" class="tag"
                      id="{{optionValue.option_value}}"
                      [value]="optionValue.option_label"
                      (selectionChange)="onInputChange(ppQuestion.mappingField, optionValue, $event)">
                      {{optionValue.option_label}}
                    </mat-chip-option>
                  }
                </mat-chip-listbox>
                @if (personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
                  <div class="reg-err">
                    {{ppQuestion.helpText}}
                  </div>
                }
              </div>
            }
          }

          <!-- Preferred study abroad country -->
          @for (ppQuestion of questions; track ppQuestion) {
            @if (ppQuestion.displayFormat.value === 'SELECT_BOX' && ppQuestion.mappingField === 'preferredCountryCode') {
              <div class="ques-wrap mb44 mb28-700">
                <label class="mb4 d-inline-block">{{ppQuestion.label}}</label>
                <mat-chip-listbox class="tag-list" formControlName="{{ppQuestion.mappingField}}" id="{{ppQuestion.mappingField}}" [attr.aria-label]="ppQuestion.label">
                  @for (optionValue of ppQuestion.options; track optionValue) {
                    <mat-chip-option tabindex="0" [aria-label]="ppQuestion.options.option_label" class="tag"
                      id="{{optionValue.option_value}}"
                      [value]="optionValue.option_label"
                      (selectionChange)="onInputChange(ppQuestion.mappingField, optionValue, $event)">
                      {{optionValue.option_label}}
                    </mat-chip-option>
                  }
                </mat-chip-listbox>
                @if (personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
                  <div class="reg-err">
                    {{ppQuestion.helpText}}
                  </div>
                }
              </div>
            }
          }

          <!-- Preferred study level -->
          @for (ppQuestion of questions; track ppQuestion) {
            @if (ppQuestion.displayFormat.value === 'SELECT_BOX' && ppQuestion.mappingField === 'preferredStudyLevel') {
              <div class="ques-wrap mb44 mb28-700">
                <label class="mb4 d-inline-block">{{ppQuestion.label}}</label>
                <mat-chip-listbox class="tag-list" formControlName="{{ppQuestion.mappingField}}" id="{{ppQuestion.mappingField}}" [attr.aria-label]="ppQuestion.label">
                  @for (optionValue of ppQuestion.options; track optionValue) {
                    <mat-chip-option tabindex="0" [aria-label]="ppQuestion.options.option_label" class="tag"
                      id="{{optionValue.option_value}}"
                      [value]="optionValue.option_label"
                      (selectionChange)="onInputChange(ppQuestion.mappingField, optionValue, $event)">
                      {{optionValue.option_label}}
                    </mat-chip-option>
                  }
                </mat-chip-listbox>
                @if (personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
                  <div class="reg-err">
                    {{ppQuestion.helpText}}
                  </div>
                }
              </div>
            }
          }

          <!-- When would you like to start studying? -->
          @for (ppQuestion of questions; track ppQuestion) {
            @if (ppQuestion.displayFormat.value === 'SELECT_BOX' && ppQuestion.mappingField === 'studyPlanTimeline') {
              <div class="ques-wrap dropdown-field mb44 mb28-700">
                <label class="mb4 d-inline-block">{{ppQuestion.label}}</label>
                <mat-form-field [ngClass]="personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'slct-boxes relative input-error':'slct-boxes relative'">
                  <mat-select formControlName="{{ppQuestion.mappingField}}" id="{{ppQuestion.mappingField}}" aria-label="{{ppQuestion.label}}">
                    @for (optionValue of ppQuestion.options; track optionValue) {
                      <mat-option
                        [value]="optionValue.option_label"
                        (click)="onInputChange(ppQuestion.mappingField, optionValue)"
                        id="{{optionValue.option_value}}">
                        {{optionValue.option_label}}
                      </mat-option>
                    }
                  </mat-select>
                  @if (personalDetailsForm.get(ppQuestion.mappingField)?.value) {
                    <button
                      (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()" aria-label="Clear selection"
                      type="button" class="select-clear-icon right-52">
                      <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
                    </button>
                  }
                </mat-form-field>
                @if (personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
                  <div class="reg-err">
                    {{ppQuestion.helpText}}
                  </div>
                }
              </div>
            }
          }

          <!-- Primary Financial Source / How Did You Hear -->
          @for (ppQuestion of questions; track ppQuestion) {
            @if (ppQuestion.displayFormat.value === 'SELECT_BOX' && (ppQuestion.mappingField === 'primaryFinancialSource' || ppQuestion.mappingField === 'howDidYouHear')) {
              <div class="ques-wrap dropdown-field mb44 mb28-700">
                <label class="mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
                  <span class="optional-text"> {{optionalText}}</span>
                }</label>
                <mat-form-field [ngClass]="personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted ? 'slct-boxes relative input-error' : 'slct-boxes relative'">
                  <mat-select formControlName="{{ppQuestion.mappingField}}" id="{{ppQuestion.mappingField}}" aria-label="{{ppQuestion.label}}">
                    @for (optionValue of ppQuestion.options; track optionValue) {
                      <mat-option
                        [value]="optionValue.option_label"
                        (click)="onInputChange(ppQuestion.mappingField, optionValue)"
                        id="{{optionValue.option_value}}">
                        {{optionValue.option_label}}
                      </mat-option>
                    }
                  </mat-select>
                  @if (personalDetailsForm.get(ppQuestion.mappingField)?.value) {
                    <button
                      (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()" aria-label="Clear selection"
                      type="button" class="select-clear-icon right-52">
                      <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
                    </button>
                  }
                </mat-form-field>
                @if (personalDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
                  <div class="reg-err">
                    {{ppQuestion.helpText}}
                  </div>
                }
              </div>
            }
          }

        </div>
        <div class="primary-btn-cnr">
          <button class="primary-btn" (click)="nextButton()">{{nextText}}</button>
        </div>
      </div>
    </form>
  </div>

  @if (showLearnMorePopup) {
    <div class="fixed-overlay">
      <div class="learn-more-popup relative">
        <p class="farro-header h5 mb12 mb8-700">{{learnMoreTitleText}}</p>
        <div class="mb28 mb24-700">
          <p>{{learnMoreIntroText}}</p>
          <br>
          <p class="font-bold">{{learnMorePoint1TitleText}}</p>
          <p>{{learnMorePoint1DescText}}</p>
          <br>
          <p class="font-bold">{{learnMorePoint2TitleText}}</p>
          <p>{{learnMorePoint2DescText}}</p>
          <br>
          <p class="font-bold">{{learnMorePoint3TitleText}}</p>
          <p>{{learnMorePoint3DescText}}</p>
        </div>
        <div class="flex flex-column gap8">
          <button class="primary-btn text-uppercase" aria-label="OK" (click)="closeLearnMorePopup()">{{okText}}</button>
        </div>
      </div>
    </div>
  }

<button class="scroll-top-btn flex items-center justify-center" [class.visible]="showScrollBtn" [class.scrolling]="isScrolling" [disabled]="isScrolling" (click)="scrollToTop()" aria-label="Scroll to top">
  <img src="./assets/icons/arrow-up-icon.svg" alt="Go to top arrow icon" width="24" height="24" />
</button>
